const relatedProductsMapping = (data) => {
    const mappedData = {};
    mappedData.items = data.map((item) => {
      let images = item?.relationships?.field_components?.data.find(component => {
        return component.type === "paragraph--product_images"
      })

      let langcode = item.attributes.path?.langcode == 'en' ? '' : '/' + item.attributes.path?.langcode;

      return {
        id: item.id,
        frontImageSrc: images?.field_desktop_img[0]?.url || '',
        frontImageAlt: images?.field_desktop_img[0]?.alt || '',
        backLayerSrc: images?.field_back_effect_img[0]?.url || '',
        backLayerAlt: images?.field_back_effect_img[0]?.alt || '',
        middleLayerSrc: images?.field_effect_img[0]?.url || '',
        middleLayerAlt: images?.field_effect_img[0]?.alt || '',
        cta: item?.attributes ? {
          title: item.attributes.title,
          alt: item.attributes.title || '',
          href: langcode + item.attributes.path?.alias || '/',
          ariaLabel: item.attributes.title || '',
        } : {}
      };
    });

    return mappedData;
};


export default relatedProductsMapping;
